import React, { useEffect, useRef, useState } from "react";
import {
    Typography,
    Button,
    Input,
    IconButton,
    Tooltip,
    Avatar
} from "@material-tailwind/react";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from 'react-tiny-popover';
import ShowLoader from "@/components/Loader";
import ScrollToTop from "@/components/ScrollToTop";
import {
    MagnifyingGlassIcon,
    XCircleIcon,
    InformationCircleIcon,
    ChatBubbleOvalLeftEllipsisIcon,
    ChevronDownIcon,
    EllipsisVerticalIcon,
    TruckIcon,
    DocumentArrowDownIcon,
    Bars3BottomLeftIcon,
    StarIcon
} from "@heroicons/react/24/solid";
import {
    approveOrderByFinance,
    crApproveRejectOrder,
    fetchAssignedMembers,
    fetchOrderItems,
    getOrderById,
    sendOrderToCRManager,
    updateVendorAssigmentApprovel,
    cancelOrderByAdmin,
    updatePurchasedStatus,
    approveRejectPurchase,
    actionByFinanceOrder,
} from "@/store/slices/orderSlice";
import useHasPermission from "@/components/useHasPermission";
import OrderChat from "./order-chat";
import OrderCustomerInfo from "./order-customer-info";
import OrderSummary from "./order-summary";
import OrderRefundRequests from "./order-refund-requests";
import OrderPayments from "./order-payments";
import Toaster from "@/components/Toaster";
import DocumentViewModal from "@/components/DocumentViewModal";
import OrderRfq from "./order-rfq";
import VendorVarientPriceModal from "./order-modals/vendor-varient-price-modal";
import Swal from "sweetalert2";
import OrderDeadlinePopover from "./order-deadline-popover";
import ViewAssignedMembers from "./order-modals/view-assigned-members";
import AssignDeliveryAgentModal from "./order-modals/assign-order-to-dp-modal";
import ViewVendorVarientPriceModal from "./order-modals/view-vendor-varient-price-modal";
import ViewDeliveryTimelineRouteModal from "./order-modals/view-delivery-timeline-route-modal";
import ViewUploadedProofModal from "./order-modals/view-uploaded-proof-modal";
import ViewAssignedDeliveryAgentModal from "./order-modals/view-assigned-delivery-agent-modal";
import EditRFQCommissionDeadline from "./order-modals/edit-rfq-commission-deadline-modal";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import AssignMultipleItemToDeliveryAgentModal from "./order-modals/assign-multiple-order-item-to-dp-modal";
import { ClockIcon } from "@heroicons/react/24/solid";
import { fetchTimeLine } from "@/store/slices/orderSlice";
import TimeLineModal from "./order-modals/timeline-modal";
import ReassignRfqModal from "../rfqs/rfq-modals/reassign-rfq-modal";
import moment from "moment";
import AssignCRTeamMemberModal from "./order-modals/assign-order-to-cr-team-member-modal";
import { useTranslation } from "react-i18next";
import ViewUploadedPickupProofModal from "./order-modals/view-uploaded-pickup-proof-modal";
import AssignFinanceTeamMemberModal from "./order-modals/assign-order-to-finance-team-member-modal";

let action_options = [];
export function OrderItemsTracking() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { t } = useTranslation('order');
    const { t: ct } = useTranslation('common');

    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const rfq_id = searchParams.get("rfq_id");
    const sourceOrderFilter = new URLSearchParams(location.state?.from || "").get("filter");
    // const hidePurchasePendingPopover = ["pending_for_approval"].includes(sourceOrderFilter);
    const hidePurchasePendingPopover = ["pending_for_approval", "payment_issue", "cancelled"].includes(sourceOrderFilter);

    const [search, setSearch] = useState('');
    const [activeTab, setActiveTab] = useState("orders");
    const [isFilterPopoverOpen, setIsFilterPopoverOpen] = useState(false);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [isActionPopoverOpen, setIsActionPopoverOpen] = useState(false);
    const [isDelivaryPopoverOpen, setIsDelivaryPopoverOpen] = useState(false);
    const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);
    const [isAssignTeamModalOpen, setIsAssignTeamModalOpen] = useState(false);
    const [isAssignFinanceTeamModalOpen, setIsAssignFinanceTeamModalOpen] = useState(false);

    const [isSetPOFile, setPOFile] = useState(false);
    const [filter, setFilter] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [openViewModal, setOpenViewModal] = useState(false);

    const [actionMenuOptions, setActionMenuOptions] = useState([]);
    const [isMemberShow, setIsMemberShow] = useState(false);

    const hasSummaryPermission = useHasPermission("order.view");
    const hasUpdatePermission = useHasPermission(`order.update`);
    const hasViewVendorPermission = useHasPermission(`assign-vendor.view`);
    const hasEditVendorPermission = useHasPermission(`assign-vendor.add`) || useHasPermission(`assign-vendor.update`);
    const hasViewDPPermission = useHasPermission(`assign-delivery-partner.view`);
    const hasEditDPPermission = useHasPermission(`assign-delivery-partner.add`) || useHasPermission(`assign-delivery-partner.update`);
    const hasAddMemberPermission = useHasPermission(`member.add`);

    const { user } = useSelector((state) => state.user);
    const hideSelectedItemsForAdmin =
        ["Administrator", "Sub Admin"].includes(user?.roles?.[0]) && sourceOrderFilter === "pending_for_approval";
    const { order_details, order_items, assigned_members, loading, list_loading } = useSelector((state) => state.order);
    const procurementAssignment = order_details?.assigned_details?.filter((d) => d.role === "Procurement") || [];
    const myProcurementDesignation = procurementAssignment
        .find((d) => d.assigned_to?.id === user?.id)?.designation?.toLowerCase();
    const isProcurementManager = myProcurementDesignation === "manager";
    const hasProcurementMember = procurementAssignment.some((d) => (d.designation || '').toLowerCase() === 'member');
    const groups = assigned_members?.groups || [];

    const financeAssignment = order_details?.assigned_details?.filter((d) => d.role === "Finance") || [];
    const myFinanceDesignation = financeAssignment
        .find((d) => d.assigned_to?.id === user?.id)?.designation?.toLowerCase();

    const isFinanceManagerUser = user?.roles?.[0] === "Finance" && (user?.parent_id == null || myFinanceDesignation === "manager");
    const isFinanceMemberUser = user?.roles?.[0] === "Finance" && !isFinanceManagerUser;
    const hasFinanceMemberAssigned = financeAssignment.some((d) => d.designation?.toLowerCase() === "member");
    const financeManagerStatus = order_details?.finance_manager_status;

    const effectiveRfqId = rfq_id || order_details?.rfq_id;
    const lastFetchKeyRef = useRef("");
    const latestQueryRef = useRef({ rfqId: null, search: "" });

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [openAssignModal, setOpenAssignModal] = useState(false);

    const [isDeliveryTimelinePopoverOpen, setIsDeliveryTimelinePopoverOpen] = useState({});
    const [deliveryTimelineModalOpen, setDeliveryTimelineModalOpen] = useState(false);
    const [deliveryTimelineContext, setDeliveryTimelineContext] = useState(null);
    const [isOpenViewUploadedProof, setIsOpenViewUploadedProof] = useState(false);
    const [isEditCommissionModalOpen, setIsEditCommissionModalOpen] = useState(false);
    const [isAssignMultipleItemToDPModalOpen, setIsAssignMultipleItemToDPModalOpen] = useState(false);

    const [isCheckedItemPopoverOpen, setIsCheckedItemPopoverOpen] = useState(false);
    const [checkedItems, setCheckedItems] = useState([]);

    const [isOpenViewUploadedPickupProof, setIsOpenViewUploadedPickupProof] = useState(false);

    // Priority Color Map
    const priorityColorMap = {
        high: "bg-red-500",
        medium: "bg-yellow-500",
        low: "bg-green-500",
    };

    const isAlreadyCancelled =
        order_details?.delivery_status === 'cancelled' ||
        order_details?.order_status === 'cancelled';

    useEffect(() => {
        if (id) dispatch(getOrderById(id));
    }, [id, dispatch]);

    useEffect(() => {
        if (!effectiveRfqId || !id) return;

        const key = `${id}:${effectiveRfqId}`;
        if (lastFetchKeyRef.current === key) return;
        lastFetchKeyRef.current = key;

        dispatch(fetchOrderItems({ rfq_id: effectiveRfqId, search: '' }));

        dispatch(fetchAssignedMembers({
            order_id: id,
            rfq_id: effectiveRfqId,
            search: ''
        }));

    }, [effectiveRfqId, id, dispatch]);

    useEffect(() => {
        latestQueryRef.current = { rfqId: effectiveRfqId, search };
    }, [effectiveRfqId, search]);

    useEffect(() => {
        const { rfqId, search: s } = latestQueryRef.current || {};
        if (!rfqId) return;
        dispatch(fetchOrderItems({ rfq_id: rfqId, search: s || '', sort_order: filter }));
    }, [filter, dispatch]);

    const handleSearch = (event) => {
        if (event.key === "Enter" && search) {
            if (!effectiveRfqId) return;
            dispatch(fetchOrderItems({ rfq_id: effectiveRfqId, search: search }));
        } else if (event.key === "Backspace" && search.length === 0) {
            if (!effectiveRfqId) return;
            dispatch(fetchOrderItems({ rfq_id: effectiveRfqId, search: '' }));
        }
    };

    const handleSearchClick = () => {
        if (!effectiveRfqId) return;
        dispatch(fetchOrderItems({ rfq_id: effectiveRfqId, search: search }));
    };

    const handleRemoveSearch = () => {
        setSearch('');
        if (!effectiveRfqId) return;
        dispatch(fetchOrderItems({ rfq_id: effectiveRfqId, search: '' }));
    };

    const toggleActionPopover = (itemId) => {
        setIsActionPopoverOpen(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };
    const toggleDelivaryPopover = (itemId) => {
        setIsDelivaryPopoverOpen(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };

    const toggleDeliveryTimelinePopover = (itemId) => {
        setIsDeliveryTimelinePopoverOpen(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };

    const totalItems = order_items?.length || 0;

    const [dpModal, setDpModal] = useState(false);
    const [selectedDelivaryPartaner, setselectedDelivaryPartaner] = useState(null);
    const [viewDpContext, setViewDpContext] = useState(null);

    const assignOrderItemToDeliveryAgent = (item, vendor, delivery_partner) => {
        if (vendor?.is_admin_approved === 'pending' || vendor?.is_admin_approved === 'rejected') {
            Toaster.error("Vendor status has been rejected or pending by the admin. Please assign a different vendor for approval.");
            setIsDelivaryPopoverOpen(false);
            return;
        }
        setselectedDelivaryPartaner(delivery_partner);
        setSelectedProduct(item);
        setDpModal(vendor);
    };

    const viewAssignedDeliveryAgent = (item, vendor, delivery_partner) => {
        setViewDpContext({
            itemId: order_details?.id,
            rfq_product_id: item?.rfq_product_id,
            vendor,
            delivery_partner,
            customer: order_details?.customer,
        });
    };

    const openDeliveryTimeline = (item, vendor, delivery_partner) => {
        const deliveryAssignment = order_details?.assigned_order_to_delivery?.find(
            (delivery) => delivery.id === delivery_partner?.id
        );

        setDeliveryTimelineContext({
            orderId: id,
            vendor,
            // deliveryPartner: delivery_partner,

            deliveryPartner: {
                ...delivery_partner,
                delivery_proofs: deliveryAssignment?.delivery_proofs || []
            },

            customer: { latitude: delivery_partner?.latitude || order_details?.rfq?.latitude, longitude: delivery_partner?.longitude || order_details?.rfq?.latitude }

        });
        setDeliveryTimelineModalOpen(true);
    };

    // Product Purchased Action Handler
    // const handleProductPurchased = (productIds) => {
    //     Swal.fire({
    //         title: "Are you sure?",
    //         text: "Do you want to mark the selected product(s) as purchased?",
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#3085d6",
    //         cancelButtonColor: "#d33",
    //         confirmButtonText: "Yes, Purchase!"
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             dispatch(updatePurchasedStatus({ rfq_product_ids: productIds, is_purchased: "yes" }))
    //                 .unwrap()
    //                 .then((res) => {
    //                     if (res?.status) {
    //                         Toaster.success("Product purchased status updated successfully.");
    //                         setCheckedItems([]);
    //                         if (effectiveRfqId) {
    //                             dispatch(fetchOrderItems({ rfq_id: effectiveRfqId, search: search || '', sort_order: filter }));
    //                         }
    //                     } else {
    //                         Toaster.error(res?.message || "Failed to update purchase status.");
    //                     }
    //                 })
    //                 .catch(() => Toaster.error("Something went wrong."));
    //         }
    //     });
    // };

    const handleProductPurchased = (productIds) => {

        const itemsWithoutVendor = order_items?.filter(
            (row) =>
                productIds.includes(row.rfq_product_id) &&
                (!row?.vendors || row.vendors.length === 0)
        ) || [];

        if (itemsWithoutVendor.length > 0) {
            Toaster.error(t('assign_vendor_before_purchase'));
            return;
        }

        Swal.fire({
            title: '<span style="font-size: 20px; font-weight: 600; color: #1e293b;">Upload Purchase Invoice</span>',
            html: `
                <div style="text-align: left; padding: 4px 0;">
                    <label 
                        for="purchaseInvoiceFile" 
                        id="dropZone"
                        style="
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            border: 2px dashed #cbd5e1;
                            border-radius: 12px;
                            padding: 24px 16px;
                            background-color: #f8fafc;
                            cursor: pointer;
                            transition: all 0.2s ease-in-out;
                        "
                        onmouseover="this.style.borderColor='#3b82f6'; this.style.backgroundColor='#eff6ff';"
                        onmouseout="this.style.borderColor='#cbd5e1'; this.style.backgroundColor='#f8fafc';"
                    >
                        <svg style="width: 40px; height: 40px; color: #3b82f6; margin-bottom: 8px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
                        </svg>
                        <span id="fileLabelText" style="font-weight: 600; font-size: 14px; color: #334155; margin-bottom: 4px;">
                            Click to upload or drag & drop
                        </span>
                        <span style="font-size: 12px; color: #64748b;">
                            PDF, JPG, JPEG, PNG, or WEBP (Max 5 MB)
                        </span>
                        <input
                            type="file"
                            id="purchaseInvoiceFile"
                            accept="image/*,.pdf"
                            style="display: none;"
                        />
                    </label>
                    <div id="selectedFileInfo" style="display: none; margin-top: 10px; font-size: 13px; color: #059669; font-weight: 500; text-align: center;"></div>
                </div>
            `,
            showCancelButton: true,
            confirmButtonColor: "#2563eb",
            cancelButtonColor: "#64748b",
            confirmButtonText: "Upload & Mark Purchased",
            cancelButtonText: "Cancel",
            focusConfirm: false,
            didOpen: () => {
                const fileInput = document.getElementById("purchaseInvoiceFile");
                const fileLabelText = document.getElementById("fileLabelText");
                const selectedFileInfo = document.getElementById("selectedFileInfo");

                fileInput.addEventListener("change", (e) => {
                    const selectedFile = e.target.files?.[0];
                    if (selectedFile) {
                        fileLabelText.textContent = selectedFile.name;
                        selectedFileInfo.textContent = `Selected: ${selectedFile.name} (${(selectedFile.size / (1024 * 1024)).toFixed(2)} MB)`;
                        selectedFileInfo.style.display = "block";
                    }
                });
            },
            preConfirm: () => {
                const fileInput = document.getElementById("purchaseInvoiceFile");
                const file = fileInput?.files?.[0];

                if (!file) {
                    Swal.showValidationMessage("Please select an invoice file.");
                    return false;
                }

                const allowedTypes = [
                    "application/pdf",
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "image/webp",
                ];

                if (!allowedTypes.includes(file.type)) {
                    Swal.showValidationMessage("Only PDF, JPG, JPEG, PNG, and WEBP files are allowed.");
                    return false;
                }

                const maxSize = 5 * 1024 * 1024; // 5 MB

                if (file.size > maxSize) {
                    Swal.showValidationMessage("File size must be less than or equal to 5 MB.");
                    return false;
                }

                return file;
            },
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(
                    updatePurchasedStatus({
                        rfq_product_ids: productIds,
                        is_purchased: "yes",
                        purchase_invoice_file: result.value,
                    })
                )
                    .unwrap()
                    .then((res) => {
                        if (res?.status) {
                            Toaster.success(
                                res?.message || "Product purchased status updated successfully."
                            );
                            setCheckedItems([]);

                            if (effectiveRfqId) {
                                dispatch(
                                    fetchOrderItems({
                                        rfq_id: effectiveRfqId,
                                        search: search || "",
                                        sort_order: filter,
                                    })
                                );
                            }
                        } else {
                            Toaster.error(
                                res?.message || "Failed to update purchase status."
                            );
                        }
                    })
                    .catch((err) => {
                        Toaster.error(err?.message || "Something went wrong.");
                    });
            }
        });
    };

    const handleApproveRejectPurchase = (productIds, action) => {
        if (action === "reject") {
            Swal.fire({
                title: "Reject Purchase Invoice",
                input: "textarea",
                inputLabel: "Reason for rejection",
                inputPlaceholder: "Type your reason here...",
                showCancelButton: true,
                confirmButtonText: "Reject",
                confirmButtonColor: "#d33",
                cancelButtonText: "Cancel",
                inputValidator: (value) => {
                    if (!value || value.trim().length < 3) {
                        return "Please provide a reason (min 3 characters).";
                    }
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(approveRejectPurchase({
                        rfq_product_ids: productIds,
                        action: "reject",
                        rejection_reason: result.value,
                    }))
                        .unwrap()
                        .then((res) => {
                            if (res?.status) {
                                Toaster.success(res?.message || "Purchase invoice rejected.");
                                setCheckedItems([]);
                                if (effectiveRfqId) {
                                    dispatch(fetchOrderItems({ rfq_id: effectiveRfqId, search: search || '', sort_order: filter }));
                                }
                            } else {
                                Toaster.error(res?.message || "Failed to reject purchase.");
                            }
                        })
                        .catch((err) => Toaster.error(err?.message || "Something went wrong."));
                }
            });
            return;
        }

        Swal.fire({
            title: "Approve Purchase Invoice?",
            text: "This will mark the product as purchased and ready for delivery partner assignment.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Approve!",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(approveRejectPurchase({ rfq_product_ids: productIds, action: "approve" }))
                    .unwrap()
                    .then((res) => {
                        if (res?.status) {
                            Toaster.success(res?.message || "Purchase approved successfully.");
                            setCheckedItems([]);
                            if (effectiveRfqId) {
                                dispatch(fetchOrderItems({ rfq_id: effectiveRfqId, search: search || '', sort_order: filter }));
                            }
                        } else {
                            Toaster.error(res?.message || "Failed to approve purchase.");
                        }
                    })
                    .catch((err) => Toaster.error(err?.message || "Something went wrong."));
            }
        });
    };

    useEffect(() => {
        let options = [];

        if (hasEditDPPermission) {
            action_options = [{ label: t('assign_delivery_agent_button'), value: 'assign_delivery_agent' }];
        }

        const crApproveOptions = [
            { label: t('reject_button'), value: "rejected" },
            { label: t('approve_button'), value: "approved" },
        ];
        if (
            user?.roles[0] === "City Representative" && user?.parent_id == null &&
            order_details?.is_send_to_city_rep != null && order_details?.city_representative_approval == null
        ) {
            crApproveOptions.forEach((option) => {
                if (!options.some((o) => o.value === option.value)) {
                    options.unshift(option);
                }
            });
        }
        // const crOptions2 = { label: t('send_to_manager_button'), value: "sendToManager" };
        // if (user?.roles[0] === 'City Representative' && user?.parent_id != null && order_details?.is_send_to_city_rep == null) {
        //     if (!options.some(o => o.value === 'sendToManager')) {
        //         options.unshift(crOptions2);
        //     }
        // }

        const financeOption = { label: t('send_to_admin_button'), value: "sendToAdmin" };
        if (user?.roles[0] === 'Finance' && user?.parent_id == null && order_details?.finance_approval == 'no') {
            if (user?.roles[0] !== 'Finance' && !options.some(o => o.value === 'sendToAdmin')) {
                options.unshift(financeOption);
            }
        }

        if (
            isFinanceMemberUser &&
            hasUpdatePermission &&
            order_details?.finance_approval !== 'yes' &&
            (financeManagerStatus == 'not_sent' || financeManagerStatus === 'rejected')
        ) {
            if (!options.some(o => o.value === 'sendToFinanceManager')) {
                options.unshift({ label: t('send_to_manager_button'), value: 'sendToFinanceManager' });
            }
        }

        // const canManagerAct = !hasFinanceMemberAssigned || financeManagerStatus === 'pending';
        const canManagerAct = financeManagerStatus === 'pending';

        if (
            isFinanceManagerUser &&
            hasUpdatePermission &&
            order_details?.finance_approval === 'no' &&
            canManagerAct
        ) {
            if (!options.some(o => o.value === 'financeReject')) {
                options.unshift({ label: t('finance_reject_button'), value: 'financeReject' });
            }
            if (!options.some(o => o.value === 'financeApprove')) {
                options.unshift({ label: t('finance_approve_button'), value: 'financeApprove' });
            }
        }

        const hasActiveDeliveryPartner = order_items?.some(
            (item) => item?.delivery_partners && item.delivery_partners.length > 0
        );

        const adminOptions2 = [
            { label: t('commission_deadline_button'), value: "edit_commission" },
        ];

        if (!hasActiveDeliveryPartner) {
            adminOptions2.push({ label: t('reassign_order_button'), value: "reassign_order" });
        }

        if (order_details?.assigned_details?.length > 0) {
            adminOptions2.forEach((option) => {
                // if (user?.roles[0] === "Finance" && option.value === "edit_commission") {
                //     return;
                // }
                if (!options.some((o) => o.value === option.value)) {
                    options.unshift(option);
                }
            });
        }

        // const crOptions1 = [
        //     { label: t("assign_team_member"), value: "assign" },
        // ];
        // if (hasAddMemberPermission && user?.parent_id == null && user?.roles?.[0] === "City Representative") {
        //     crOptions1.forEach((option) => {
        //         if (!options.some((o) => o.value === option.value)) {
        //             options.unshift(option);
        //         }
        //     });
        // }
        const assignedDetails = order_details?.assigned_details || [];

        const isCityRepresentativeAssigned = assignedDetails.some(
            (item) => item.role === "City Representative" && item.designation === "Member"
        );

        const crOptions1 = [
            { label: t("assign_team_member"), value: "assign" },
        ];

        if (
            hasAddMemberPermission &&
            user?.parent_id == null &&
            user?.roles?.[0] === "City Representative" &&
            !isCityRepresentativeAssigned
        ) {
            crOptions1.forEach((option) => {
                if (!options.some((o) => o.value === option.value)) {
                    options.unshift(option);
                }
            });
        }

        // NEW: Finance Manager -> Assign Team Member
        const isFinanceMemberAssigned = assignedDetails.some(
            (item) => item.role === "Finance" && item.designation?.toLowerCase() === "member"
        );

        const isFinanceManagerLoggedIn =
            user?.roles?.[0] === "Finance" &&
            (user?.parent_id == null || user?.designation?.toLowerCase() === "manager");

        const financeOptions1 = [
            { label: t("assign_team_member"), value: "assign_finance_member" },
        ];

        if (isFinanceManagerLoggedIn && hasAddMemberPermission && !isFinanceMemberAssigned) {
            financeOptions1.forEach((option) => {
                if (!options.some((o) => o.value === option.value)) {
                    options.unshift(option);
                }
            });
        }

        const isCancelDisabled =
            ['delivered', 'partialdelivery'].includes(order_details?.delivery_status) ||
            order_details?.order_status === 'completed';

        if ((user?.roles[0] === 'Administrator' || user?.roles[0] === 'Sub Admin') && !isAlreadyCancelled) {
            if (!options.some(o => o.value === 'cancel_order')) {
                options.push({
                    label: t('cancel_order_button'),
                    value: 'cancel_order',
                    disabled: isCancelDisabled
                });
            }
        }

        setActionMenuOptions(options);

    }, [dispatch, order_details, user, order_items]);

    const cancelOrder = async () => {
        const { value: reason } = await Swal.fire({ // This uses Swal, which is not part of the i18n scope of this file.
            title: "Cancel Order",
            input: "textarea",
            inputLabel: "Reason for cancellation",
            inputPlaceholder: "Type your reason here...",
            showCancelButton: true,
            confirmButtonText: "Cancel Order",
            confirmButtonColor: "#d33",
            cancelButtonText: "Go Back",
            inputValidator: (value) => {
                if (!value || value.trim().length < 3) {
                    return "Please provide a reason (min 3 characters).";
                }
                if (value.trim().length > 300) {
                    return "Reason cannot exceed 300 characters.";
                }
            }
        });

        if (!reason) return;

        dispatch(cancelOrderByAdmin({ order_id: order_details?.id, reason }))
            .unwrap()
            .then((res) => {
                if (res?.status) {
                    Toaster.success("Order cancelled successfully.");
                    dispatch(getOrderById(id));
                } else {
                    Toaster.error(res?.message || "Failed to cancel order.");
                }
            })
            .catch(() => Toaster.error("Failed to cancel order."));
    };

    const editVendor = (item) => {
        setOpenModal(item);
        setIsActionPopoverOpen({});
    }
    const viewVendor = (item) => {
        setOpenViewModal(item);
        setIsActionPopoverOpen([]);
    }

    const orderSendToCRManager = () => {
        if (order_details?.is_send_to_city_rep !== null && order_details?.city_representative_approval === 'no') { // This is a toaster message, not a label.
            Toaster.error('This order has already been submitted to the Manager and is awaiting approval.');
            return;
        }
        if (order_details?.is_send_to_city_rep !== null && order_details?.city_representative_approval === 'yes') { // This is a toaster message, not a label.
            Toaster.error('Order has already been approved by Manager.');
            return;
        }
        Swal.fire({ // This uses Swal, which is not part of the i18n scope of this file.
            title: "Are you sure?",
            text: 'Do you really want to send this order to the Manager?',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes send it!"
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(sendOrderToCRManager({ order_id: order_details?.id })).unwrap().then((res) => {
                    if (res?.status) {
                        Toaster.success(`Order sent to admin successfully!`);
                        dispatch(getOrderById(id));
                    } else {
                        Toaster.error(res?.message);
                    }
                }).catch((error) => {
                    console.error("Sending failed:", error);
                    Toaster.error("Sending failed, please try again.");
                });
            }
        });
    }

    const approveRejectOrder = async (value) => {
        if (order_details?.city_representative_approval === 'no' && value === 'no') { // This is a toaster message, not a label.
            Toaster.error('This order has already been rejected.');
            return;
        }
        if (order_details?.city_representative_approval === 'yes' && value === 'yes') { // This is a toaster message, not a label.
            Toaster.error('This order has already been approved.');
            return;
        }

        if (value === "no") { // This uses Swal, which is not part of the i18n scope of this file.
            Swal.fire({
                title: "Reject Order",
                text: "Please provide the reason for rejecting this order.",
                icon: "warning",
                input: "textarea",
                inputLabel: "Reason",
                inputPlaceholder: "Enter rejection reason...",
                inputAttributes: {
                    maxlength: 100,
                    autocapitalize: "off",
                    autocorrect: "off",
                },
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Reject",
                preConfirm: (reason) => {
                    const validationValue = reason?.trim() || "";

                    if (!validationValue) {
                        Swal.showValidationMessage("Reason is required.");
                        return false;
                    }

                    if (validationValue.length < 3) {
                        Swal.showValidationMessage("Reason must be at least 3 characters.");
                        return false;
                    }

                    if (validationValue.length > 100) {
                        Swal.showValidationMessage("Reason cannot exceed 100 characters fbgrfefgbrfeg.");
                        return false;
                    }

                    return validationValue;
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(
                        crApproveRejectOrder({
                            order_id: order_details?.id,
                            approval: "no",
                            reason: result.value,
                        })
                    )
                        .unwrap()
                        .then((res) => {
                            if (res?.status) {
                                dispatch(getOrderById(id));
                                Toaster.success("Order rejected successfully!");
                            } else {
                                Toaster.error(res?.message || "Failed to reject order.");
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            Toaster.error("Something went wrong.");
                        });
                }
            });

            return;
        }

        var msg = value == 'yes' ? 'approve' : value;
        let text = `Do you want to ${msg} this order?`;
        // This uses Swal, which is not part of the i18n scope of this file.
        Swal.fire({
            title: "Are you sure?",
            text: `${text}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(crApproveRejectOrder({ order_id: order_details?.id, approval: value })).unwrap().then((res) => {
                    if (res?.status) {
                        dispatch(getOrderById(id));
                        Toaster.success(`Order approved successfully!`);
                    } else {
                        Toaster.error(res?.message);
                    }
                }).catch((error) => {
                    console.error("Changes failed:", error);
                    Toaster.error("Changes failed, please try again.");
                });
            }
        });
    };

    const financeApproveOrder = async () => {
        Swal.fire({ // This uses Swal, which is not part of the i18n scope of this file.
            title: "Are you sure?",
            text: `You want to approve this order and forward it to the admin for further processing?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(approveOrderByFinance({ order_id: order_details?.id, approval: 'yes' })).unwrap().then((res) => {
                    if (res?.status) {
                        Toaster.success(`Order approved and send to admin successfully!`);
                        dispatch(getOrderById(id));
                        navigate('/dashboard/orders');
                    } else {
                        Toaster.error(res?.message);
                    }
                }).catch((error) => {
                    console.error("Changes failed:", error);
                    Toaster.error("Changes failed, please try again.");
                });
            }
        });
    };

    const handleSingleCheck = (id) => {
        setCheckedItems(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
    };

    const handleCheckAll = (e) => {
        if (e.target.checked) {
            let filteredItems = [];
            if (user?.roles[0] === "Procurement") {
                filteredItems = (isProcurementManager && hasProcurementMember)
                    ? order_items
                        ?.filter((row) => row?.is_purchased === false &&
                            row?.procurement_approval_status === 'pending' &&
                            row?.purchase_invoice_file)
                        .map((row) => row.rfq_product_id) || []
                    : order_items
                        ?.filter((row) => row?.is_purchased === false &&
                            !(row?.procurement_approval_status === 'pending' && row?.purchase_invoice_file))
                        .map((row) => row.rfq_product_id) || [];
            }
            setCheckedItems(filteredItems);
        } else {
            setCheckedItems([]);
        }
    };

    const validItems =
        order_items?.filter((row) => {
            // if (user?.roles[0] === "Procurement") {
            //     return row?.is_purchased === false;
            // }
            if (user?.roles[0] === "Procurement") {
                if (isProcurementManager && hasProcurementMember) {
                    return row?.is_purchased === false &&
                        row?.procurement_approval_status === 'pending' &&
                        row?.purchase_invoice_file;
                }
                return row?.is_purchased === false &&
                    !(row?.procurement_approval_status === 'pending' && row?.purchase_invoice_file);
            }
            return (!row?.delivery_partners || row.delivery_partners.length === 0) &&
                (row?.vendors && row.vendors.length > 0);
        }) || [];

    const isAllChecked =
        validItems.length > 0 &&
        validItems.every((item) => checkedItems.includes(item.rfq_product_id));

    const [timelineData, setTimelineData] = useState([]);
    const [timelineLoading, setTimelineLoading] = useState(false);
    const [isTimelineModalOpen, setIsTimelineModalOpen] = useState(false);

    useEffect(() => {
        if (id) {
            setTimelineLoading(true);
            dispatch(fetchTimeLine(id)).unwrap()
                .then((res) => {
                    const data = res?.data || (Array.isArray(res) ? res : []);
                    setTimelineData(data);
                    setTimelineLoading(false);
                })
                .catch((err) => {
                    console.error("Timeline fetch error:", err);
                    setTimelineLoading(false);
                });
        }
    }, [id, dispatch]);

    const latestTimeline = timelineData.length > 0 ? timelineData[timelineData.length - 1] : null;

    const approveRejectVendorAssigment = (vendor, status) => {
        dispatch(updateVendorAssigmentApprovel({ rfq_product_vendor_id: vendor.rfq_product_vendor_id, is_admin_approved: status }))
            .unwrap()
            .then((res) => {
                if (res?.status) {
                    Toaster.success(`Vendor assignment ${status} successfully.`);
                    if (effectiveRfqId) dispatch(fetchOrderItems({ rfq_id: effectiveRfqId, search: search }));
                } else {
                    Toaster.error(res?.message || "Operation failed.");
                }
            });
    };

    const sendOrderToFinanceManager = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "Send this order to your Finance Manager for approval?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Send",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(actionByFinanceOrder({ order_id: id, action: 'send_to_manager' }))
                    .unwrap()
                    .then((res) => {
                        if (res?.status) {
                            Toaster.success(res.message);
                            dispatch(getOrderById(id));
                        } else {
                            Toaster.error(res?.message);
                        }
                    })
                    .catch((err) => Toaster.error(err?.message || "Failed to send."));
            }
        });
    };

    const financeApproveAction = () => {
        Swal.fire({
            title: t('finance_approve_confirm_title'),
            text: t('finance_approve_confirm_text'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('yes'),
            cancelButtonText: t('cancel'),
        }).then((res) => {
            if (res.isConfirmed) {
                dispatch(actionByFinanceOrder({ order_id: id, action: 'approve' }))
                    .unwrap()
                    .then((r) => {
                        if (r?.status) {
                            Toaster.success(r.message);
                            dispatch(getOrderById(id));
                        } else {
                            Toaster.error(r?.message);
                        }
                    })
                    .catch((e) => Toaster.error(e?.message || t('finance_action_failed')));
            }
        });
    };

    const financeRejectAction = () => {
        Swal.fire({
            title: t('finance_reject_title'),
            input: "textarea",
            inputLabel: t('finance_reject_reason_label'),
            inputPlaceholder: t('finance_reject_reason_placeholder'),
            inputAttributes: {
                maxlength: 250,
                autocapitalize: "off",
                autocorrect: "off",
            },
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: t('submit'),
            cancelButtonText: t('cancel'),
            preConfirm: (value) => {
                const val = value?.trim() || "";
                if (!val) {
                    Swal.showValidationMessage(t('finance_reject_reason_required'));
                    return false;
                }
                if (val.length < 5) {
                    Swal.showValidationMessage(t('finance_reject_reason_min'));
                    return false;
                }
                if (val.length > 250) {
                    Swal.showValidationMessage(t('finance_reject_reason_max'));
                    return false;
                }
                return val;
            },
        }).then((res) => {
            if (res.isConfirmed) {
                dispatch(actionByFinanceOrder({ order_id: id, action: 'reject', reason: res.value }))
                    .unwrap()
                    .then((r) => {
                        if (r?.status) {
                            Toaster.success(r.message || t('finance_reject_success'));
                            dispatch(getOrderById(id));
                        } else {
                            Toaster.error(r?.message);
                        }
                    })
                    .catch((e) => Toaster.error(e?.message || t('finance_action_failed')));
            }
        });
    };

    return (
        <div className="mt-5 mb-8 flex flex-col gap-6">
            {loading && <ShowLoader />}
            <ScrollToTop />

            {/* Header Section */}
            <div className="flex flex-col gap-4 px-4 md:px-6">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 overflow-x-auto">
                    <div className="flex flex-col gap-2 w-fit shrink-0">
                        <div className="flex flex-wrap items-center gap-3">
                            <Link
                                onClick={() => navigate(-1)}
                                className="flex items-center text-blue-600 hover:text-blue-800 transition shrink-0">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                            </Link>
                            {order_details?.assigned_details?.[0]?.priority && (
                                <span className={`w-2 h-2 rounded-full ${priorityColorMap[order_details.assigned_details[0].priority]}`}></span>
                            )}
                            <Typography variant="h5" color="blue-gray" className="font-bold shrink-0">
                                {t('po_id_label')}: {order_details?.order_id}
                            </Typography>
                        </div>
                        {order_details?.purchase_order_number && (
                            <div className="flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-lg shrink-0 w-fit">
                                {order_details?.purchase_order_file && (
                                    <DocumentArrowDownIcon
                                        className="h-4 w-4 text-gray-500 cursor-pointer hover:text-blue-600"
                                        onClick={() => setPOFile(order_details.purchase_order_file)}
                                    />
                                )}
                                <span className="text-sm font-medium text-gray-700">{t('po_label')}: {order_details.purchase_order_number}</span>
                            </div>
                        )}

                        {order_details?.rfq?.rfq_reference && (
                            <div className="flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-lg shrink-0 w-fit">
                                <span className="text-sm font-medium text-gray-700">
                                    {t('cs_rfq_ref_id_label')}: {order_details.rfq.rfq_reference}
                                </span>
                            </div>
                        )}
                    </div>

                    <div className="w-full md:w-auto flex items-start gap-6 md:ml-auto min-w-0">
                        {/* Timeline Status Bar */}
                        <div className="flex items-center gap-3 px-0">
                            {timelineLoading ? (
                                <div className="animate-pulse flex items-center gap-3 bg-gray-50 rounded-lg px-4 py-2">
                                    <div className="rounded-full bg-slate-200 h-8 w-8"></div>
                                    <div className="flex-1 space-y-2 py-1">
                                        <div className="h-2 bg-slate-200 rounded w-24"></div>
                                        <div className="h-2 bg-slate-200 rounded w-48"></div>
                                    </div>
                                </div>
                            ) : latestTimeline ? (
                                <div
                                    onClick={() => setIsTimelineModalOpen(true)}
                                    className="flex items-center gap-3 bg-blue-50 border border-blue-100 rounded-lg px-4 py-2 shadow-sm cursor-pointer hover:bg-blue-100 transition-colors group max-w-[75vw] lg:max-w-[30vw] xl:max-w-[20vw]"
                                >
                                    <div className="bg-blue-500 p-1.5 rounded-full flex-shrink-0 group-hover:scale-110 transition-transform">
                                        <ClockIcon className="h-4 w-4 text-white" />
                                    </div>
                                    <div className="flex flex-col min-w-0">
                                        <span className="text-[10px] uppercase tracking-wider text-blue-600 font-bold">
                                            {t('status_label')}
                                        </span>
                                        <div className="flex items-center gap-1.5 min-w-0">
                                            <Typography className="text-sm font-semibold text-gray-900 truncate max-w-[300px]">
                                                {latestTimeline.message}
                                            </Typography>
                                            <span className="text-gray-400 text-xs flex-shrink-0">•</span>
                                            <span className="text-xs text-gray-500 font-medium flex-shrink-0">
                                                {latestTimeline.date_time ? moment(latestTimeline.date_time).format("D MMM, h:mm A") : "N/A"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex items-center gap-2 bg-gray-50 border border-gray-100 rounded-lg px-4 py-2">
                                    <InformationCircleIcon className="h-4 w-4 text-gray-400" />
                                    <span className="text-xs text-gray-400 italic">
                                        {t('no_activity_history')}
                                    </span>
                                </div>
                            )}
                        </div>

                        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
                            {order_details?.delivery_status === 'cancelled' && <span className="text-[10px] px-3 py-2 rounded-full text-center font-bold bg-red-100 text-red-700">
                                {order_details?.delivery_status?.charAt(0).toUpperCase() + order_details?.delivery_status?.slice(1)}
                            </span>}
                            {activeTab === "orders" && <div className="w-full sm:w-auto flex items-center gap-2">
                                <div className="w-full sm:w-64 relative">
                                    <Input
                                        label={ct("search")}
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        onKeyUp={handleSearch}
                                        icon={!search && <MagnifyingGlassIcon className="h-5 w-5" />}
                                        className={search ? 'pr-10' : ''}
                                    />
                                    {search && (
                                        <IconButton
                                            variant="text"
                                            size="sm"
                                            className="!absolute right-1 top-1"
                                            onClick={handleRemoveSearch}
                                        >
                                            <XCircleIcon className="h-5 w-5 text-red-500" />
                                        </IconButton>
                                    )}
                                </div>
                                {search && (
                                    <Button
                                        variant="outlined"
                                        className="flex items-center border-gray-300 capitalize font-bold bg-black text-white whitespace-nowrap"
                                        onClick={handleSearchClick}
                                    >
                                        {t('search_button')}
                                    </Button>
                                )}
                            </div>}
                            <div className="flex items-center gap-3">
                                {order_details && order_details?.assigned_details !== null && user?.roles?.[0] === 'City Representative' && (
                                    <OrderDeadlinePopover order_data={order_details} />
                                )}
                            </div>
                        </div>

                        {/* Dropdown Action Controls Block */}
                        <div className="flex justify-end">
                            {(hasUpdatePermission && !hideSelectedItemsForAdmin && actionMenuOptions.length > 0 && !isAlreadyCancelled) && (
                                <Popover
                                    isOpen={isPopoverOpen}
                                    positions={["bottom", "right"]}
                                    padding={4}
                                    align="end"
                                    onClickOutside={() => setIsPopoverOpen(false)}
                                    content={
                                        <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                            {actionMenuOptions.map((option) => (
                                                <button
                                                    key={option.value}
                                                    onClick={() => {
                                                        setIsPopoverOpen(false);
                                                        if (option.value === "approved") approveRejectOrder('yes');
                                                        if (option.value === "rejected") approveRejectOrder('no');
                                                        if (option.value === "sendToManager") orderSendToCRManager();
                                                        if (option.value === "sendToAdmin") financeApproveOrder();
                                                        if (option.value === "sendToFinanceManager") sendOrderToFinanceManager();
                                                        if (option.value === "financeApprove") financeApproveAction();
                                                        if (option.value === "financeReject") financeRejectAction();
                                                        if (option.value === "edit_commission") setIsEditCommissionModalOpen(true);
                                                        if (option.value === "cancel_order") cancelOrder();
                                                        if (option.value === "reassign_order") setIsReassignModalOpen(true);
                                                        if (option.value === "assign") {
                                                            if (order_details?.order_status === 'completed') {
                                                                Toaster.error('The order has already been completed.');
                                                            } else {
                                                                setIsAssignTeamModalOpen(true);
                                                            }
                                                        }
                                                        if (option.value === "assign_finance_member") {
                                                            if (order_details?.order_status === 'completed') {
                                                                Toaster.error('The order has already been completed.');
                                                            } else {
                                                                setIsAssignFinanceTeamModalOpen(true);
                                                            }
                                                        }
                                                    }}
                                                    disabled={option.disabled}
                                                    className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                >
                                                    {option?.label}
                                                </button>
                                            ))}
                                        </div>
                                    }
                                >
                                    <button
                                        onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                                        className="flex items-center justify-between w-28 gap-2 px-4 py-2.5 rounded-lg bg-yellow-700 text-gray-900 font-medium hover:bg-yellow-800 transition-all shadow-sm"
                                    >
                                        <span className="text-sm">{t('action_label')}</span>
                                        <ChevronDownIcon className="w-4 h-4" />
                                    </button>
                                </Popover>
                            )}
                        </div>
                    </div>
                </div>

                {/* Tabs Section */}
                <div className="flex items-center gap-2 flex-wrap">
                    <button
                        onClick={() => setActiveTab("orders")}
                        className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all text-sm font-medium ${activeTab === "orders" ? "bg-black text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
                    >
                        <TruckIcon className="h-4 w-4" />
                        {t('order_items_tab')}
                    </button>
                    <button
                        onClick={() => setActiveTab("chat")}
                        className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all text-sm font-medium ${activeTab === "chat" ? "bg-black text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
                    >
                        <ChatBubbleOvalLeftEllipsisIcon className="h-4 w-4" />
                        {t('chat_tab')}
                    </button>
                    <button
                        onClick={() => setActiveTab("customer")}
                        className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all text-sm font-medium ${activeTab === "customer" ? "bg-black text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
                    >
                        <InformationCircleIcon className="h-4 w-4" />
                        {t('customer_info_tab')}
                    </button>
                    <button
                        onClick={() => setActiveTab("payments")}
                        className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all text-sm font-medium ${activeTab === "payments" ? "bg-black text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
                    >
                        <InformationCircleIcon className="h-4 w-4" />
                        {t('payments_tab')}
                    </button>
                    <button
                        onClick={() => setActiveTab("rfqs")}
                        className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all text-sm font-medium ${activeTab === "rfqs" ? "bg-black text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
                    >
                        <InformationCircleIcon className="h-4 w-4" />
                        {t('purchase_order_tab')}
                    </button>
                    <button
                        onClick={() => setActiveTab("refund")}
                        className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all text-sm font-medium ${activeTab === "refund" ? "bg-black text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
                    >
                        <InformationCircleIcon className="h-4 w-4" />
                        {t('refund_request_tab')}
                    </button>
                </div>

                <div className="flex justify-end">
                    <div className="flex -space-x-2 cursor-pointer" onClick={() => setIsMemberShow(true)}>
                        {groups?.map((group, index) => (
                            group?.members?.map((row, i) => (
                                // <Tooltip key={row?.assigned_to?.id ?? `${index}-${i}`} content={t('team_members_tooltip')}>
                                <Tooltip key={row?.assigned_to?.id ?? `${index}-${i}`} content={t(row?.assigned_to?.name) || t('team_members_tooltip')}>
                                    <Avatar
                                        src={`${row?.assigned_to?.profile_image}` || "/img/default-avatar.png"}
                                        alt={`${row?.assigned_to?.name}`}
                                        size="sm"
                                        className="border-2 border-white"
                                    />
                                </Tooltip>
                            ))
                        ))}
                    </div>
                </div>
            </div>

            {/* Main Content Body */}
            <div className="px-4 md:px-6 w-full">
                {activeTab === "orders" ? (
                    <div className="w-full">
                        <div className="w-full flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-4">
                            <div className="flex items-center gap-4">
                                <Typography variant="h6" color="blue-gray" className="font-bold">
                                    {t('track_items_title', { count: totalItems })}
                                </Typography>
                            </div>

                            <div className="flex items-center gap-3 flex-wrap">
                                <Popover
                                    isOpen={isFilterPopoverOpen}
                                    positions={["bottom"]}
                                    onClickOutside={() => setIsFilterPopoverOpen(false)}
                                    content={
                                        <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                            <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2" onClick={() => { setFilter(''); setIsFilterPopoverOpen(false); }}>{t('latest_sort')}</button>
                                            <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2" onClick={() => { setFilter('asc'); setIsFilterPopoverOpen(false); }}>{t('sort_ascending')}</button>
                                            <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2" onClick={() => { setFilter('desc'); setIsFilterPopoverOpen(false); }} >{t('sort_descending')}</button>
                                        </div>
                                    }
                                >
                                    <Button
                                        onClick={() => setIsFilterPopoverOpen(!isFilterPopoverOpen)}
                                        variant="outlined"
                                        className="flex items-center gap-2 border-gray-300 capitalize"
                                    >
                                        <Bars3BottomLeftIcon className="h-4 w-4" />
                                        {filter ? `(${filter})` : ''}
                                    </Button>
                                </Popover>

                                {user?.roles[0] === "Procurement" ? (
                                    (isProcurementManager && hasProcurementMember) ? (
                                        <Popover
                                            isOpen={isCheckedItemPopoverOpen}
                                            positions={["bottom"]}
                                            onClickOutside={() => setIsCheckedItemPopoverOpen(false)}
                                            content={
                                                <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                                    <button
                                                        className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                        onClick={() => {
                                                            setIsCheckedItemPopoverOpen(false);
                                                            handleApproveRejectPurchase(checkedItems, 'approve');
                                                        }}
                                                    >
                                                        {t('approve_purchase_button')}
                                                    </button>
                                                    <button
                                                        className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                        onClick={() => {
                                                            setIsCheckedItemPopoverOpen(false);
                                                            handleApproveRejectPurchase(checkedItems, 'reject');
                                                        }}
                                                    >
                                                        {t('reject_purchase_button')}
                                                    </button>
                                                </div>
                                            }
                                        >
                                            <Button
                                                onClick={() => setIsCheckedItemPopoverOpen(!isCheckedItemPopoverOpen)}
                                                variant="outlined"
                                                className="flex items-center gap-2 bg-black text-white capitalize"
                                                disabled={checkedItems.length === 0}
                                            >
                                                {t('product_purchased_button', { count: checkedItems.length })} <ChevronDownIcon className="h-4 w-4" />
                                            </Button>
                                        </Popover>
                                    ) : (
                                        <Button
                                            onClick={() => handleProductPurchased(checkedItems)}
                                            variant="outlined"
                                            className="flex items-center gap-2 bg-black text-white capitalize"
                                            disabled={checkedItems.length === 0}
                                        >
                                            {t('product_purchased_button', { count: checkedItems.length })}
                                        </Button>
                                    )
                                ) : (
                                    hasEditDPPermission && !hideSelectedItemsForAdmin && (
                                        <Popover
                                            isOpen={isCheckedItemPopoverOpen}
                                            positions={["bottom"]}
                                            onClickOutside={() => setIsCheckedItemPopoverOpen(false)}
                                            content={
                                                <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                                    {action_options.map((opt) => (
                                                        <button key={opt.value} onClick={() => setIsAssignMultipleItemToDPModalOpen(true)} className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize">{opt.label}</button>
                                                    ))}
                                                </div>
                                            }
                                        >
                                            <Button
                                                onClick={() => setIsCheckedItemPopoverOpen(!isCheckedItemPopoverOpen)}
                                                variant="outlined"
                                                className="flex items-center gap-2 bg-black text-white capitalize"
                                                disabled={checkedItems.length === 0}
                                            >
                                                {t('selected_items_button')} ({checkedItems.length}) <ChevronDownIcon className="h-4 w-4" />
                                            </Button>
                                        </Popover>
                                    )
                                )}
                            </div>
                        </div>

                        <div className="w-full overflow-x-auto rounded-lg mx-0">
                            <table className="w-full min-w-[800px]">
                                <thead>
                                    <tr className="border-b border-gray-300">
                                        <th className="text-left py-3 px-2 first:pl-0 last:pr-0 text-xs font-bold text-gray-700">
                                            {(hasEditDPPermission || user?.roles[0] === "Procurement") && (
                                                <input type="checkbox" className="w-4 h-4 accent-green cursor-pointer" onChange={handleCheckAll} checked={isAllChecked} />
                                            )}
                                        </th>
                                        <th className="text-left py-3 px-2 first:pl-0 last:pr-0 text-xs font-bold text-gray-700 w-[300px]">{t('product_header')}</th>
                                        <th className="text-left py-3 px-2 first:pl-0 last:pr-0 text-xs font-bold text-gray-700">{t('quantity_header')}</th>
                                        <th className="text-left py-3 px-2 first:pl-0 last:pr-0 text-xs font-bold text-gray-700">{t('installation_header')}</th>
                                        <th className="text-left py-3 px-2 first:pl-0 last:pr-0 text-xs font-bold text-gray-700">{t('unit_price_header')}</th>
                                        <th className="text-left py-3 px-2 first:pl-0 last:pr-0 text-xs font-bold text-gray-700">{t('vendor_header')}</th>
                                        <th className="text-left py-3 px-2 first:pl-0 last:pr-0 text-xs font-bold text-gray-700">{t('delivery_agent_header')}</th>
                                        <th className="text-left py-3 px-2 first:pl-0 last:pr-0 text-xs font-bold text-gray-700"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list_loading ? <tr><td colSpan={8} className="text-center"> <div role="status">
                                        <svg aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                        </svg>
                                    </div></td></tr> : ''}

                                    {!list_loading && order_items?.length === 0 && (
                                        <tr><td colSpan={8} className="text-center py-10 text-blue-gray-500">{t('no_data_found')}.</td></tr>
                                    )}

                                    {order_items?.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="border-b border-gray-300 hover:bg-gray-50 transition">
                                                <td className="py-4 px-4 first:pl-0 last:pr-0">
                                                    {item?.is_purchased !== false && (
                                                        user?.roles[0] === "Procurement" ? (
                                                            <input
                                                                type="checkbox"
                                                                className="w-4 h-4 accent-green cursor-pointer mt-1"
                                                                onChange={() => handleSingleCheck(item.rfq_product_id)}
                                                                checked={checkedItems.includes(item.rfq_product_id)}
                                                                // disabled={item?.is_purchased !== false}
                                                                disabled={
                                                                    isProcurementManager && hasProcurementMember
                                                                        ? !(item?.is_purchased === false && item?.procurement_approval_status === 'pending' && item?.purchase_invoice_file)
                                                                        : (item?.is_purchased !== false || (item?.procurement_approval_status === 'pending' && item?.purchase_invoice_file))
                                                                }
                                                            />
                                                        ) : (
                                                            hasEditDPPermission && (
                                                                <input type="checkbox" className="w-4 h-4 accent-green cursor-pointer mt-1" onChange={() => handleSingleCheck(item.rfq_product_id)} checked={checkedItems.includes(item.rfq_product_id)} disabled={
                                                                    (item?.delivery_partners && item.delivery_partners.length > 0) ||
                                                                    (!item?.vendors || item.vendors.length === 0)
                                                                } />
                                                            )
                                                        )
                                                    )}
                                                </td>
                                                <td className="py-4 px-4 first:pl-0 last:pr-0 align-top">
                                                    <div className="flex items-start gap-3">
                                                        <Avatar
                                                            src={item.product_image}
                                                            alt={item.product_name}
                                                            size="md"
                                                            variant="rounded"
                                                            className="border border-gray-200"
                                                        />
                                                        <div className="flex-1 min-w-0">
                                                            <Typography variant="small" className="font-bold text-gray-900">
                                                                {item.product_name}
                                                            </Typography>
                                                            <Typography variant="small" className="text-gray-500">
                                                                {item?.currency_code} {item.sku_number}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="py-4 px-4 first:pl-0 last:pr-0">
                                                    <Typography variant="small" className="font-medium text-gray-900">
                                                        {item.quantity}
                                                    </Typography>
                                                </td>
                                                <td className="py-4 px-4 first:pl-0 last:pr-0">
                                                    <input
                                                        type="checkbox"
                                                        className="w-4 h-4 accent-[#000000] cursor-pointer"
                                                        checked={item?.is_installation}
                                                        readOnly
                                                    />
                                                </td>
                                                <td className="py-4 px-4 first:pl-0 last:pr-0">
                                                    <Typography variant="small" className="font-medium text-gray-900">
                                                        {item?.currency_code} {item.customer_price}
                                                    </Typography>
                                                </td>
                                                <td className="py-4 px-4 first:pl-0 last:pr-0">
                                                    {item?.vendors?.map((vendor, vIdx) => (
                                                        <div key={vendor?.rfq_product_vendor_id ?? vIdx} className="flex items-center gap-1 mb-2 last:mb-0">
                                                            <Typography variant="small" className="text-gray-900">
                                                                {vendor.vendor_name}
                                                            </Typography>
                                                            {vendor.price && (
                                                                <Tooltip
                                                                    placement="top"
                                                                    interactive={true}
                                                                    className="bg-white text-gray-800 border border-gray-200 shadow-xl rounded-lg px-6 py-4 min-w-[320px]"
                                                                    content={
                                                                        <div className="text-sm space-y-3">
                                                                            <Typography variant="small" className="font-bold text-blue-gray-900 border-b border-gray-200 pb-2 text-center">
                                                                                {t('vendor_details_title')}
                                                                            </Typography>
                                                                            <div className="space-y-2.5">
                                                                                <div className="flex items-start">
                                                                                    <span className="text-[11px] uppercase tracking-wider font-semibold text-gray-500 w-28 shrink-0">{t('vendor_name_label')}:</span>
                                                                                    <span className="font-bold text-gray-900 leading-tight">{vendor.vendor_name}</span>
                                                                                </div>
                                                                                <div className="flex items-center">
                                                                                    <span className="text-[11px] uppercase tracking-wider font-semibold text-gray-500 w-28 shrink-0">{t('email_label')}:</span>
                                                                                    <span className="text-gray-700 font-medium truncate">{vendor.email}</span>
                                                                                </div>
                                                                                <hr className="border-gray-100" />
                                                                                <div className="flex flex-col gap-2">
                                                                                    <div className="flex items-center">
                                                                                        <span className="font-medium text-gray-600 w-28 shrink-0">{t('quantity_label')}:</span>
                                                                                        <span className="text-gray-900 font-bold">{vendor.product_quantity}</span>
                                                                                    </div>
                                                                                    <div className="flex items-center">
                                                                                        <span className="font-medium text-gray-600 w-28 shrink-0">{t('unit_price_label')}:</span>
                                                                                        <span className="text-green-600 font-bold">{item?.currency_code} {vendor.price}</span>
                                                                                    </div>
                                                                                    <div className="flex items-start">
                                                                                        <span className="font-medium text-gray-600 w-28 shrink-0">{t('pickup_label')}:</span>
                                                                                        <span className="text-gray-800 font-medium">{vendor?.pickup_location}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {vendor.vendor_file && (
                                                                                <div className="pt-3 mt-1 border-t border-gray-200">
                                                                                    <a href={vendor.vendor_file} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-blue-600 hover:text-blue-700 transition font-bold text-xs">
                                                                                        <DocumentArrowDownIcon className="h-4 w-4" />
                                                                                        {t('download_vendor_file')}
                                                                                    </a>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    }
                                                                >
                                                                    <div className="flex items-center justify-center h-6 w-6 rounded-full bg-gray-100 hover:bg-gray-200 transition cursor-pointer">
                                                                        <InformationCircleIcon className="h-4 w-4 text-gray-500" />
                                                                    </div>
                                                                </Tooltip>
                                                            )}

                                                            {/* Guard condition added: Hide context options if item isn't purchased yet */}
                                                            {item?.is_purchased !== false && (
                                                                <Popover
                                                                    isOpen={isDelivaryPopoverOpen[vendor?.rfq_product_vendor_id]}
                                                                    positions={["bottom", "left"]}
                                                                    padding={4}
                                                                    onClickOutside={() => toggleDelivaryPopover(vendor?.rfq_product_vendor_id)}
                                                                    content={
                                                                        <div className="bg-white shadow-xl rounded-md w-40 flex flex-col z-50 border border-gray-100 py-1">
                                                                            {hasViewDPPermission && (
                                                                                <button
                                                                                    className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                                    onClick={() => viewAssignedDeliveryAgent(item, vendor, item?.delivery_partners[vIdx])}
                                                                                >
                                                                                    {t('view_assigned_dp')}
                                                                                </button>
                                                                            )}
                                                                            {(hasEditDPPermission && order_details?.delivery_status !== 'cancelled') && (
                                                                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                                    onClick={() => assignOrderItemToDeliveryAgent(item, vendor, item?.delivery_partners[vIdx])}>
                                                                                    {t('assign_edit_dp_button')}
                                                                                </button>
                                                                            )}
                                                                            {((user.roles[0] == 'Administrator' || user.roles[0] == 'Sub Admin') && vendor?.is_admin_approved === 'pending') && (
                                                                                <>
                                                                                    <button
                                                                                        className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                                        onClick={() => approveRejectVendorAssigment(vendor, 'approved')}
                                                                                    >
                                                                                        {t('approve_vendor_assignment')}
                                                                                    </button>
                                                                                    <button
                                                                                        className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                                        onClick={() => approveRejectVendorAssigment(vendor, 'rejected')}
                                                                                    >
                                                                                        {t('reject_vendor_assignment')}
                                                                                    </button>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    }
                                                                >
                                                                    <IconButton
                                                                        variant="text"
                                                                        size="sm"
                                                                        onClick={() => toggleDelivaryPopover(vendor?.rfq_product_vendor_id)}
                                                                    >
                                                                        <EllipsisVerticalIcon className="h-5 w-5 text-gray-600" />
                                                                    </IconButton>
                                                                </Popover>
                                                            )}

                                                            {vendor?.is_admin_approved === 'pending' && (
                                                                <span className="w-auto min-w-[110px] text-[11px] px-3 py-1 rounded-full text-center font-semibold capitalize bg-yellow-100 text-yellow-700 ml-auto ">
                                                                    {t('admin_approval_pending')}
                                                                </span>
                                                            )}
                                                            {vendor?.is_admin_approved === 'rejected' && (
                                                                <span className="w-auto min-w-[110px] text-[11px] px-3 py-1 rounded-full text-center font-semibold capitalize bg-red-100 text-red-700 ml-auto">
                                                                    {t('rejected_by_admin')}
                                                                </span>
                                                            )}
                                                            {vendor?.is_admin_approved === 'approved' && (
                                                                <span className="w-auto min-w-[110px] text-[11px] px-3 py-1 rounded-full text-center font-semibold capitalize bg-green-100 text-green-700 ml-auto">
                                                                    {t('approved_by_admin')}
                                                                </span>
                                                            )}
                                                        </div>
                                                    ))}
                                                </td>
                                                <td className="py-4 px-4 first:pl-0 last:pr-0">
                                                    {item?.delivery_partners?.map((delivery_partner, dIdx) => (
                                                        <div key={delivery_partner?.id ?? dIdx} className="flex items-center gap-1">
                                                            <Typography variant="small" className="text-gray-900">
                                                                {delivery_partner.full_name}
                                                            </Typography>
                                                            <Tooltip
                                                                placement="top"
                                                                className="bg-white text-gray-800 border border-gray-200 shadow-lg rounded-lg px-3 py-2"
                                                                content={
                                                                    <div className="text-sm space-y-1">
                                                                        <div className="flex items-center gap-2">
                                                                            <span className="font-medium text-gray-600">{t('qty_label')}:</span>
                                                                            <span className="text-gray-900">{delivery_partner?.quantity}</span>
                                                                        </div>
                                                                        <div className="flex items-center gap-2">
                                                                            <span className="font-medium text-gray-600">{t('delivery_charge_label')}:</span>
                                                                            <span className="text-green-600 font-semibold">
                                                                                {item?.currency_code} {delivery_partner?.delivery_charge}
                                                                            </span>
                                                                        </div>
                                                                        <div className="flex items-center gap-2">
                                                                            <span className="font-medium text-gray-600">{t('delivery_info_label')}:</span>
                                                                            <span className="text-green-600 font-semibold">
                                                                                {delivery_partner?.delivery_address}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            >
                                                                <div className="flex items-center justify-center h-6 w-6 rounded-full bg-gray-100 hover:bg-gray-200 transition cursor-pointer">
                                                                    <InformationCircleIcon className="h-4 w-4 text-gray-500" />
                                                                </div>
                                                            </Tooltip>

                                                            {delivery_partner?.status !== 'rejected' && (
                                                                <Popover
                                                                    isOpen={Boolean(isDeliveryTimelinePopoverOpen[delivery_partner?.id ?? dIdx])}
                                                                    positions={["bottom", "left"]}
                                                                    padding={4}
                                                                    onClickOutside={() => toggleDeliveryTimelinePopover(delivery_partner?.id ?? dIdx)}
                                                                    content={
                                                                        <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                                                            <button
                                                                                className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                                onClick={() => {
                                                                                    if (isOpenViewUploadedPickupProof) {
                                                                                        setIsOpenViewUploadedPickupProof(false);
                                                                                    } else {
                                                                                        setIsOpenViewUploadedPickupProof(delivery_partner?.id);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                {t('view_pickup_proof')}
                                                                            </button>
                                                                            <button
                                                                                className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                                onClick={() => {
                                                                                    if (isOpenViewUploadedProof) {
                                                                                        setIsOpenViewUploadedProof(false);
                                                                                    } else {
                                                                                        setIsOpenViewUploadedProof(delivery_partner?.id);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                {t('view_uploaded_proof')}
                                                                            </button>
                                                                            {order_details?.delivery_status !== 'cancelled' && <button
                                                                                className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                                onClick={() => {
                                                                                    const vendor = item?.vendors?.[dIdx] ?? null;
                                                                                    openDeliveryTimeline(item, vendor, delivery_partner);
                                                                                    toggleDeliveryTimelinePopover(delivery_partner?.id ?? dIdx);
                                                                                }}
                                                                            >
                                                                                {t('track_delivery_status')}
                                                                            </button>}
                                                                        </div>
                                                                    }
                                                                >
                                                                    <IconButton
                                                                        variant="text"
                                                                        size="sm"
                                                                        onClick={() => toggleDeliveryTimelinePopover(delivery_partner?.id ?? dIdx)}
                                                                    >
                                                                        <EllipsisVerticalIcon className="h-5 w-5 text-gray-600" />
                                                                    </IconButton>
                                                                </Popover>
                                                            )}
                                                            {delivery_partner?.delivery_timeline === 'delivered' &&
                                                                <span className="w-auto min-w-[110px] text-[11px] px-3 py-1 rounded-full text-center font-semibold capitalize bg-green-100 text-green-700 ml-auto">
                                                                    {t('delivered_status')}
                                                                </span>
                                                            }
                                                            {delivery_partner?.status === 'pending' && (
                                                                <span className="w-auto min-w-[110px] text-[11px] px-3 py-1 rounded-full text-center font-semibold capitalize bg-yellow-100 text-yellow-700 ml-auto">
                                                                    {t('dp_pending_status')}
                                                                </span>
                                                            )}
                                                            {['approved'].includes(delivery_partner?.status) &&
                                                                delivery_partner?.delivery_timeline !== 'delivered' && (
                                                                    <span className="w-auto min-w-[110px] text-[11px] px-3 py-1 rounded-full text-center font-semibold capitalize bg-green-100 text-green-700 ml-auto">
                                                                        {t('dp_accepted_status')}
                                                                    </span>
                                                                )}
                                                            {delivery_partner?.status === 'rejected' && (
                                                                <>
                                                                    {delivery_partner?.admin_status === 'rejected' ? (
                                                                        <span className="w-auto min-w-[110px] text-[11px] px-3 py-1 rounded-full text-center font-semibold capitalize bg-red-100 text-red-700 ml-auto">
                                                                            {t('dp_changed_status')}
                                                                        </span>
                                                                    ) : (
                                                                        <span className="w-auto min-w-[110px] text-[11px] px-3 py-1 rounded-full text-center font-semibold capitalize bg-red-100 text-red-700 ml-auto">
                                                                            {t('rejected_by_dp_status')}
                                                                        </span>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    ))}
                                                </td>
                                                <td className="py-4 px-4 first:pl-0 last:pr-0">
                                                    <div className="flex items-center gap-2">
                                                        {/* <img src={`/img/icons/logistic-van.png`} alt='logistic-van' className={`h-4 w-4 object-contain ml-4 mt-1`} /> */}
                                                        <Popover
                                                            isOpen={item?.is_purchased === false && !hidePurchasePendingPopover}
                                                            positions={["top"]}
                                                            padding={8}
                                                            content={
                                                                <div className="bg-red-500 text-white font-medium px-3 py-1.5 rounded-lg shadow-md text-xs animate-pulse">
                                                                    {t('procurement_pending_tooltip')}
                                                                </div>
                                                            }
                                                        >
                                                            <img
                                                                src={`/img/icons/logistic-van.png`}
                                                                alt="logistic-van"
                                                                className={`h-5 w-5 object-contain ml-4 mt-1 p-0.5 rounded-md transition-colors ${item?.is_purchased === false
                                                                    ? "bg-red-100 border border-red-300 animate-pulse"
                                                                    : "bg-green-100 border border-green-300"
                                                                    }`}
                                                            />
                                                        </Popover>
                                                        <Popover
                                                            isOpen={isActionPopoverOpen[item.rfq_product_id]}
                                                            positions={["bottom", "left"]}
                                                            padding={4}
                                                            onClickOutside={() => toggleActionPopover(item.rfq_product_id)}
                                                            content={
                                                                <div className="bg-white shadow-xl rounded-md w-40 flex flex-col z-50 border border-gray-100 py-1">
                                                                    {hasViewVendorPermission && <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                        onClick={() => viewVendor(item)}>{t('view_vendor_button')}</button>}
                                                                    {(hasEditVendorPermission && item?.delivery_partners?.length == 0 && order_details?.delivery_status !== 'cancelled') && <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                        onClick={() => editVendor(item)}>{t('add_edit_vendor_button')}</button>}

                                                                    {/* Procurement condition injection */}
                                                                    {/* {user?.roles[0] === "Procurement" && item?.is_purchased === false && (
                                                                        <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                            onClick={() => handleProductPurchased([item.rfq_product_id])}>
                                                                            {t('mark_as_purchased')}
                                                                        </button>
                                                                    )} */}
                                                                    {/* Procurement condition injection */}
                                                                    {user?.roles[0] === "Procurement" && item?.is_purchased === false &&
                                                                        !(item?.procurement_approval_status === 'pending' && item?.purchase_invoice_file) &&
                                                                        !(isProcurementManager && hasProcurementMember) && (
                                                                            <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                                onClick={() => handleProductPurchased([item.rfq_product_id])}>
                                                                                {item?.procurement_approval_status === 'rejected' ? t('reupload_invoice_button') : t('mark_as_purchased')}
                                                                            </button>
                                                                        )}

                                                                    {user?.roles[0] === "Procurement" && isProcurementManager &&
                                                                        item?.procurement_approval_status === 'pending' && item?.purchase_invoice_file && item?.is_purchased === false && (
                                                                            <>
                                                                                <button className="text-left text-sm text-green-700 hover:bg-gray-100 px-3 py-2"
                                                                                    onClick={() => handleApproveRejectPurchase([item.rfq_product_id], 'approve')}>
                                                                                    {t('approve_purchase_button')}
                                                                                </button>
                                                                                <button className="text-left text-sm text-red-700 hover:bg-gray-100 px-3 py-2"
                                                                                    onClick={() => handleApproveRejectPurchase([item.rfq_product_id], 'reject')}>
                                                                                    {t('reject_purchase_button')}
                                                                                </button>
                                                                            </>
                                                                        )}

                                                                    {user?.roles[0] !== "Sales Representative" && item?.purchase_invoice_file && (
                                                                        <button
                                                                            className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                                            onClick={() => {
                                                                                setPOFile(item.purchase_invoice_file);
                                                                                toggleActionPopover(item.rfq_product_id);
                                                                            }}
                                                                        >
                                                                            {t('view_purchase_invoice')}
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            }
                                                        >
                                                            <IconButton
                                                                variant="text"
                                                                size="sm"
                                                                onClick={() => toggleActionPopover(item.rfq_product_id)}
                                                            >
                                                                <EllipsisVerticalIcon className="h-5 w-5 text-gray-600" />
                                                            </IconButton>
                                                        </Popover>
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className={hasSummaryPermission && order_details ? "grid grid-cols-1 md:grid-cols-[3fr_1fr] gap-4 md:divide-x md:divide-gray-300 w-full" : "w-full"}>
                        <div className={hasSummaryPermission && order_details ? "pr-0 md:pr-4 overflow-x-auto min-h-[400px]" : "w-full"}>
                            {activeTab === "chat" && <OrderChat rfq_id={order_details?.rfq_id} customer_id={order_details?.user_id} purchase_order_file={order_details?.purchase_order_file} purchase_order_number={order_details?.purchase_order_number} />}
                            {activeTab === "customer" && <OrderCustomerInfo rfq_id={order_details?.rfq_id} />}
                            {activeTab === "payments" && <OrderPayments orderId={id} rfq_id={order_details?.rfq_id} order_details={order_details} />}
                            {activeTab === "refund" && <OrderRefundRequests orderId={id} />}
                            {activeTab === "rfqs" && <OrderRfq rfq_id={order_details?.rfq_id} />}
                        </div>
                        {hasSummaryPermission && order_details && (
                            <div className="pl-0 md:pl-5">
                                <OrderSummary rfq_id={order_details?.rfq_id} order_id={id} search={search} activeTab={activeTab} />
                            </div>
                        )}
                    </div>
                )}
            </div>
            {isSetPOFile && <DocumentViewModal documentUrl={isSetPOFile} setIsDocumentViewModalOpen={setPOFile}></DocumentViewModal>}
            {openModal && (
                <VendorVarientPriceModal
                    onClose={() => {
                        setOpenModal(false);
                        dispatch(fetchOrderItems({ rfq_id: order_details?.rfq_id, search: search, sort_order: filter }));
                    }}
                    item={openModal}
                    rfq_id={order_details?.rfq_id}
                />
            )}
            {openViewModal && (
                <ViewVendorVarientPriceModal
                    onClose={() => {
                        setOpenViewModal(false);
                    }}
                    item={openViewModal}
                    rfq_id={order_details?.rfq_id}
                />
            )}
            {isMemberShow && <ViewAssignedMembers onClose={() => setIsMemberShow(false)} rfq_id={order_details?.rfq_id} order_id={order_details?.id} />}
            {dpModal && <AssignDeliveryAgentModal
                onClose={() => {
                    setDpModal(false);
                    dispatch(fetchOrderItems({ rfq_id: order_details?.rfq_id, search: search, sort_order: filter }));
                    setIsDelivaryPopoverOpen([]);
                }}
                item={{
                    ...order_details,
                    installation_charge: selectedProduct?.installation_charge
                }}
                rfq_product_id={selectedProduct?.rfq_product_id}
                vendor={dpModal}
                initialData={selectedDelivaryPartaner}
            />
            }

            {viewDpContext && (
                <ViewAssignedDeliveryAgentModal
                    onClose={() => setViewDpContext(null)}
                    itemId={viewDpContext.itemId}
                    customer={viewDpContext.customer}
                    rfq_product_id={viewDpContext.rfq_product_id}
                    vendor={viewDpContext.vendor}
                    initialData={viewDpContext.delivery_partner}
                />
            )}

            {deliveryTimelineModalOpen && deliveryTimelineContext && (
                <ViewDeliveryTimelineRouteModal
                    onClose={() => {
                        setDeliveryTimelineModalOpen(false);
                        setDeliveryTimelineContext(null);
                        dispatch(fetchOrderItems({ rfq_id: order_details?.rfq_id, search: search }));
                    }}
                    orderId={deliveryTimelineContext.orderId}
                    vendor={deliveryTimelineContext.vendor}
                    deliveryPartner={deliveryTimelineContext.deliveryPartner}
                    customer={deliveryTimelineContext.customer}
                    onUpdateStatus={(next) => {
                        if (next === "delivered") {
                            Toaster.success("Status set to Delivered");
                        }
                    }}
                />
            )}
            {isOpenViewUploadedProof && <ViewUploadedProofModal open={isOpenViewUploadedProof ? true : false} onClose={() => setIsOpenViewUploadedProof(false)} deliveryAssignedOrderId={isOpenViewUploadedProof}></ViewUploadedProofModal>}
            {isOpenViewUploadedPickupProof && (
                <ViewUploadedPickupProofModal
                    open={isOpenViewUploadedPickupProof ? true : false}
                    onClose={() => setIsOpenViewUploadedPickupProof(false)}
                    deliveryAssignedOrderId={isOpenViewUploadedPickupProof}
                />
            )}
            {isEditCommissionModalOpen && <EditRFQCommissionDeadline isOpen={isEditCommissionModalOpen} onClose={() => setIsEditCommissionModalOpen(false)} rfqId={order_details?.rfq_id} />}
            {isAssignMultipleItemToDPModalOpen && <AssignMultipleItemToDeliveryAgentModal onClose={() => {
                setIsAssignMultipleItemToDPModalOpen(false);
                setCheckedItems([]);
            }} rfqProductIds={checkedItems} order={{
                ...order_details,
                selected_products: order_items.filter((p) =>
                    checkedItems.includes(p.rfq_product_id)
                ),
            }}
            />}
            {isTimelineModalOpen && (
                <TimeLineModal
                    onClose={() => setIsTimelineModalOpen(false)}
                    orderId={id}
                />
            )}

            {isReassignModalOpen && (
                <ReassignRfqModal
                    isOpen={isReassignModalOpen}
                    onClose={() => {
                        setIsReassignModalOpen(false);
                        if (id) dispatch(getOrderById(id));
                        if (effectiveRfqId) {
                            dispatch(fetchAssignedMembers({
                                order_id: id,
                                rfq_id: effectiveRfqId,
                                search: ''
                            }));
                        }
                    }}
                    rfqId={effectiveRfqId}
                    isOrderView={true}
                />
            )}
            {isAssignTeamModalOpen && <AssignCRTeamMemberModal isOpen={isAssignTeamModalOpen} onClose={() => setIsAssignTeamModalOpen(false)} orderId={id} assigned_details={order_details?.assigned_details} />}
            {isAssignFinanceTeamModalOpen && (
                <AssignFinanceTeamMemberModal
                    isOpen={isAssignFinanceTeamModalOpen}
                    onClose={() => setIsAssignFinanceTeamModalOpen(false)}
                    orderId={id}
                    rfqId={effectiveRfqId}
                    assigned_details={order_details?.assigned_details}
                />
            )}

        </div>
    );
}

export default OrderItemsTracking;
